export default "__VITE_ASSET__CYhwyGpb__"